import { Button, Checkbox, Col, Row, Space, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import InputBox from "../../../components/common/input";
import DropdownSelect from "../../../components/common/select";
import CommonDatePicker from "../../../components/common/datepicker";
import CommonUpload from "../../../components/common/upload-image";
import dayjs from "dayjs";
import ColorPickerForm from "../../../components/common/color-picker/ColorPickerForm";
import { useDispatch, useSelector } from "react-redux";
import {
  addTenantFun,
  updateTenantFun,
  viewTenantFun,
} from "../../../redux/reducer/TenantSlice";
import { listSubscriptionFun } from "../../../redux/reducer/SubscriptionSlice";
import { uploadFile } from "../../../redux/reducer/UploadSlice";
import FileUploadFun from "../../../components/common/fileUploadFun/FileUploadFun";
import { toast } from "react-toastify";
import { ColorPicker } from "antd";
import FileUploadTwo from "../../../components/common/fileUploadFun/FileUploadTwo";

const options = [
  { label: "Option 1", value: "1" },
  { label: "Option 2", value: "2" },
  { label: "Option 3", value: "3" },
];

const AddTenant = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const [uploadedFile, setUploadedFile] = useState(null);
  const { fileUrl } = useSelector((state) => state.upload);

  const [previewImages, setPreviewImages] = useState(() => ({
    logo: "",
  }));

  const tenentDetails = location.state?.tenentData || null;
  const {
    viewtenantDetails,
    addTenantLoading,
    updateTenantLoading,
    addTenantError,
  } = useSelector((prev) => prev?.tenant);

  useEffect(() => {
    if (tenentDetails) {
      dispatch(viewTenantFun(tenentDetails?.id));
    }
  }, [dispatch, tenentDetails]);

  useEffect(() => {
    if (viewtenantDetails && tenentDetails) {
      form.setFieldsValue({
        tenantName: viewtenantDetails.name_en || "",
        contactPerson: viewtenantDetails.contact_person_en || "",
        email: viewtenantDetails.email || "",
        phone: viewtenantDetails.mobile_no || "",
        max_user: viewtenantDetails.max_user || "",
        startDate: viewtenantDetails.subscription_start_date
          ? dayjs(viewtenantDetails.subscription_start_date)
          : null,
        endDate: viewtenantDetails.subscription_end_date
          ? dayjs(viewtenantDetails.subscription_end_date)
          : null,
        subscription_id: viewtenantDetails.subscription_id || undefined,
        default_language: viewtenantDetails.default_language || undefined,
        primary_color: viewtenantDetails.primary_color || "#000000",
        font_color: viewtenantDetails.font_color || "#000000",
        bg_color: viewtenantDetails.bg_color || "#000000",
        text_color: viewtenantDetails.text_color || "#000000",
        btn_color: viewtenantDetails.btn_color || "#000000",
        btn_text_color: viewtenantDetails.btn_text_color || "#000000",
        allowAds: viewtenantDetails.manage_advt || false,
        manage_most_listened: viewtenantDetails.manage_most_listened || false,
        manage_top_rated: viewtenantDetails.manage_top_rated || false,
        manage_celebrity: viewtenantDetails.manage_celebrity || false,
        logo: viewtenantDetails?.logo,
        ip_address: viewtenantDetails?.ip_address || "",
      });

      setPreviewImages(() => ({
        logo: viewtenantDetails.logo
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewtenantDetails.logo}`
          : null,
      }));
    }
  }, [viewtenantDetails, tenentDetails, form]);

  useEffect(() => {
    if (fileUrl) {
      form.setFieldsValue({ logo: fileUrl.rows[0]?.image_url });
    }
  }, [fileUrl, form]);

  useEffect(() => {
    if (tenentDetails) {
      form.setFieldsValue(tenentDetails);
    }
  }, [tenentDetails, form]);

  // const handleFileUpload = async (field, url) => {
  //   const data = await dispatch(uploadFile(file));
  //   setPreviewImages((prev) => ({...prev, [field]: url}))
  //   setUploadedFile(file);
  // };

  useEffect(() => {
    dispatch(listSubscriptionFun());
  }, []);

  const { listSubscription, listSubLoading, listSubError } = useSelector(
    (state) => state?.subscription
  );

  const listSubscriptionData = listSubscription.map(({ id, name_en }) => ({
    label: name_en,
    value: id,
  }));

  const languageList = [
    { label: "English", value: 1 },
    { label: "Spanish", value: 2 },
    { label: "Portuguese", value: 3 },
  ];

  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const payload = {
        email: values.email,
        name_en: values.tenantName,
        max_user: values.max_user,
        contact_person_en: values.contactPerson,
        mobile_no: values.phone,
        subscription_start_date: values?.startDate
          ? dayjs(values.startDate).format("YYYY-MM-DD")
          : null,
        subscription_end_date: values?.endDate
          ? dayjs(values.endDate).format("YYYY-MM-DD")
          : null,
        subscription_id: values.subscription_id,
        default_language: values.default_language,
        primary_color: values.primary_color, // 🎨 Ensuring colors are picked
        font_color: values.font_color, // 🎨
        bg_color: values.bg_color, // 🎨
        text_color: values.text_color, // 🎨
        btn_color: values.btn_color, // 🎨
        btn_text_color: values.btn_text_color, // 🎨
        manage_advt: values.allowAds || false,
        manage_most_listened: values.manage_most_listened || false,
        manage_top_rated: values.manage_top_rated || false,
        manage_celebrity: values.manage_celebrity || false,
        logo: values?.logo,
        ip_address: values?.ip_address || "",
        manage_ip: !!values?.ip_address,
      };

      // tenentData
      if (tenentDetails) {
        const response = await dispatch(
          updateTenantFun({ id: tenentDetails?.id, data: payload })
        );
        if (response.type === "data/update/tenant/rejected") {
          toast.error(response?.payload?.message);
        }

        if (response.type === "data/update/tenant/fulfilled") {
          toast.success("Tenant updated successfully");
          navigate(-1);
        }
      } else {
        const response = await dispatch(addTenantFun(payload));

        if (response.payload.code === 201) {
          toast.success(response?.payload?.message);
          navigate(-1);
        } else {
          toast.error(response?.payload?.message);
        }
      }
    } catch (error) {
      message.error("Error adding tenant!");
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
          {tenentDetails ? "Edit" : "Add"} Tenant Details
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button
            type="primary"
            loading={tenentDetails ? updateTenantLoading : addTenantLoading}
            onClick={() => form.submit()}
          >
            {tenentDetails ? "Update Details" : "Save Details"}
          </Button>
        </Space>
      </div>

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col xs={24} sm={18}>
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="tenantName"
                  label="Tenant’s Name"
                  rules={[
                    { required: true, message: "Please enter tenant’s name" },
                  ]}
                >
                  <InputBox
                    size="large"
                    placeholder="Enter tenant’s name"
                    className="custom-input"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="contactPerson"
                  label="Tenant’s Contact Person"
                  rules={[
                    {
                      required: true,
                      message: "Please enter contact person’s name",
                    },
                  ]}
                >
                  <InputBox
                    size="large"
                    placeholder="Enter contact person’s name"
                    className="custom-input"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="email"
                  label="Tenant’s Email Address"
                  rules={[
                    { required: true, message: "Please enter email" },
                    { type: "email", message: "Enter a valid email" },
                  ]}
                >
                  <InputBox
                    size="large"
                    placeholder="Enter email address"
                    className="custom-input"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="phone"
                  label="Tenant’s Phone Number"
                  rules={[
                    { required: true, message: "Please enter phone number" },
                  ]}
                >
                  <InputBox
                    size="large"
                    placeholder="Enter phone number"
                    className="custom-input"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="startDate"
                  label="Subscription Start Date"
                  rules={[{ required: true, message: "Select start date" }]}
                >
                  <CommonDatePicker
                    onChange={(date) =>
                      form.setFieldsValue({
                        startDate: date ? dayjs(date) : null,
                      })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="endDate"
                  label="Subscription End Date"
                  rules={[{ required: true, message: "Select end date" }]}
                >
                  <CommonDatePicker
                    disabledDate={(current) => {
                      const today = dayjs().startOf("day"); // Get today's date at the beginning of the day
                      const endDateValue = form?.getFieldValue("endDate");

                      const isBeforeToday =
                        current && current.isBefore(today, "day");
                      const isBeforeEndDate =
                        endDateValue &&
                        current &&
                        current.isBefore(endDateValue, "day");

                      return isBeforeToday;
                    }}
                    onChange={(date) =>
                      form?.setFieldsValue({
                        endDate: date ? dayjs(date) : null,
                      })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="subscription_id"
                  label="Subscription"
                  rules={[{ required: true, message: "Select a subscription" }]}
                >
                  <DropdownSelect
                    value={form.getFieldValue("subscription")}
                    onChange={(value) =>
                      form.setFieldsValue({ subscription_id: value })
                    }
                    options={listSubscriptionData}
                    placeholder="Choose..."
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="max_user"
                  label="Max User Allowed"
                  rules={[
                    {
                      required: true,
                      message:
                        "Please enter the maximum number of users allowed",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "Only numeric values are allowed",
                    },
                  ]}
                >
                  <InputBox
                    size="large"
                    placeholder="Enter maximum allowed users"
                    className="custom-input"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="default_language"
                  label="Default Notification Language"
                  rules={[
                    { required: true, message: "Select Default Lanugage" },
                  ]}
                >
                  <DropdownSelect
                    value={form.getFieldValue("default_language")}
                    onChange={(value) =>
                      form.setFieldsValue({ default_language: value })
                    }
                    options={languageList}
                    placeholder="Choose..."
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name="ip_address" label="Restricted IP">
                  <InputBox
                    size="large"
                    placeholder="Enter restricted IP"
                    className="custom-input"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>
                <div className="tableHeading">
                  App Theme
                  <Button
                    // type="primary"
                    className="btn-default-theme"
                    onClick={() => {
                      form.setFieldsValue({
                        primary_color: "#45AE51",
                        font_color: "#ffffff",
                        bg_color: "#ffffff",
                        text_color: "#000000",
                        btn_color: "#45AE51",
                        btn_text_color: "#ffffff",
                      });
                    }}
                  >
                    Apply Default Theme
                  </Button>
                </div>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item name="primary_color" label="Primary Color">
                  <ColorPicker
                    value={form.getFieldValue("primary_color")}
                    onChange={(color) =>
                      form.setFieldsValue({
                        primary_color: color.toHexString(),
                      })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item name="font_color" label="Primary Text Color">
                  <ColorPicker
                    value={form.getFieldValue("font_color")}
                    onChange={(color) =>
                      form.setFieldsValue({ font_color: color.toHexString() })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item name="bg_color" label="Background Color">
                  <ColorPicker
                    value={form.getFieldValue("bg_color")}
                    onChange={(color) =>
                      form.setFieldsValue({ bg_color: color.toHexString() })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item name="text_color" label="Secondary Text Color">
                  <ColorPicker
                    value={form.getFieldValue("text_color")}
                    onChange={(color) =>
                      form.setFieldsValue({ text_color: color.toHexString() })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item name="btn_color" label="Button Color">
                  <ColorPicker
                    value={form.getFieldValue("btn_color")}
                    onChange={(color) =>
                      form.setFieldsValue({ btn_color: color.toHexString() })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item name="btn_text_color" label="Button Text Color">
                  <ColorPicker
                    value={form.getFieldValue("btn_text_color")}
                    onChange={(color) =>
                      form.setFieldsValue({
                        btn_text_color: color.toHexString(),
                      })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>
                <Form.Item shouldUpdate>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}
                  >
                    <Form.Item name="allowAds" valuePropName="checked" noStyle>
                      <Checkbox>
                        Allow tenant to manage advertisements within the app.
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="manage_most_listened"
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Show Most Listened</Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="manage_top_rated"
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Show Top Rated</Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="manage_celebrity"
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Show Celebrities</Checkbox>
                    </Form.Item>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={6}>
            <Form.Item
              name="logo"
              label="Logo"
              rules={[{ required: true, message: "Please upload a Logo file" }]}
            >
              <FileUploadTwo
                label2={"Upload File"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) => handleUploadSuccess("logo", url)}
                initialPreview={previewImages?.logo}
              />
              {/* <FileUploadFun onFileUpload={handleFileUpload} imagePrev={`${process.env.REACT_APP_IMAGE_URL}/${viewCategory.image_url}`}  /> */}
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div></div>
    </div>
  );
};

export default AddTenant;
